export default "__VITE_ASSET__BzAqYdfE__"